<template>
    <div>
        <h1 class="screen-title">{{ $t('mySessions') }}</h1>

        <div v-if="loaded && events.length === 0" class="empty-state">
            {{ $t('noMySessions') }}
        </div>

        <template v-else>
            <template v-if="upcoming.length > 0">
                <div class="day-heading">{{ $t('upcoming') }}</div>
                <SessionCard v-for="event in upcoming" :key="event.id" :event="event" @open="openEvent" />
            </template>

            <template v-if="past.length > 0">
                <div class="day-heading">{{ $t('past') }}</div>
                <SessionCard v-for="event in past" :key="event.id" :event="event" @open="openEvent" />
            </template>
        </template>

        <SessionSheet :event="selectedEvent" @close="selectedEvent = null" @cancel="cancel" @waitlist-leave="waitlistLeave" />
    </div>
</template>

<script>
import SessionCard from '@/components/SessionCard.vue';
import SessionSheet from '@/components/SessionSheet.vue';

export default {
    name: 'MySessionsView',
    components: { SessionCard, SessionSheet },
    data() {
        return {
            events: [],
            loaded: false,
            selectedEvent: null
        };
    },
    computed: {
        // Upcoming first (soonest first); past below, most recent first.
        upcoming() {
            return this.events.filter((e) => !e.past).sort((a, b) => a.start.localeCompare(b.start));
        },
        past() {
            return this.events.filter((e) => e.past).sort((a, b) => b.start.localeCompare(a.start));
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            const response = await this.$api.get('sessions/mine');
            if (response.success) {
                this.events = response.data.events;
            }
            this.loaded = true;
        },
        openEvent(event) {
            this.selectedEvent = event;
        },
        async cancel(event) {
            const response = await this.$api.post('sessions/cancel', { session_id: event.id });
            if (response.success) {
                // Once cancelled the person is no longer signed up, so it drops off this screen.
                this.events = this.events.filter((e) => e.id !== event.id);
                this.selectedEvent = null;
                this.$store.commit('showToast', { message: this.$t('cancelSuccess'), type: 'success' });
            } else {
                this.$store.commit('showToast', { message: this.$t('genericError'), type: 'error' });
            }
        },
        async waitlistLeave(event) {
            const response = await this.$api.post('sessions/waitlist/leave', { session_id: event.id });
            if (response.success) {
                // No longer on the waiting list, so it drops off this screen too.
                this.events = this.events.filter((e) => e.id !== event.id);
                this.selectedEvent = null;
                this.$store.commit('showToast', { message: this.$t('leaveWaitlistSuccess'), type: 'success' });
            } else {
                this.$store.commit('showToast', { message: this.$t('genericError'), type: 'error' });
            }
        }
    }
};
</script>
